import ParticleImage, { Vector, forces } from 'react-particle-image'
import useWindowSize from '@rooks/use-window-size'

const particleOptions = {
  filter: ({ x, y, image }) => {
    const pixel = image.get(x, y)
    return pixel.b > 50
  },
  color: () => '#8E76D5',
  radius: () => Math.random() * 1.5 + 0.5,
  mass: () => 40,
  friction: () => 0.15,
  initialPosition: ({ canvasDimensions }) => {
    return new Vector(canvasDimensions.width / 2, canvasDimensions.height / 2)
  }
}

const motionForce = (x, y) => {
  return forces.disturbance(x, y, 5)
}

const getMoonScale = (innerWidth) => {
  if (innerWidth < 576) {
    return 0.7
  } else if (innerWidth < 768) {
    return 0.8
  } else if (innerWidth < 992) {
    return 0.9
  } else if (innerWidth < 1200) {
    return 1.0
  } else if (innerWidth < 1600) {
    return 1.1
  }
  return 1.2
}

const getScale = (innerWidth) => {
  if (innerWidth < 576) {
    return 1
  } else if (innerWidth < 768) {
    return 1.1
  } else if (innerWidth < 992) {
    return 1.2
  } else if (innerWidth < 1200) {
    return 1.4
  } else if (innerWidth < 1600) {
    return 1.55
  }
  return 1.8
}

const ParticleAvatar = ({ isMoon }) => {
  const { innerWidth, innerHeight } = useWindowSize()

  return (
    <ParticleImage
      src={isMoon ? '/moon.png' : '/0xhanson.png'}
      width={Number(innerWidth)}
      height={Number(innerHeight)}
      scale={isMoon ? getMoonScale(innerWidth) : getScale(innerWidth)}
      entropy={20}
      maxParticles={4000}
      particleOptions={particleOptions}
      mouseMoveForce={motionForce}
      touchMoveForce={motionForce}
      backgroundColor='transparent'
    />
  )
}

export default ParticleAvatar
